module.exports = __webpack_public_path__ + "static/img/ML06.0b5be69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/ML06.jpg
// module id = HUGe
// module chunks = 9